// extracted by mini-css-extract-plugin
module.exports = {"componentRoot":"BannerContent_componentRoot__u26_k"};